// P:\0PJ\synforge\frontend\components\AuthGuard.tsx v1 2026.06.30

"use client"

// 페이지 진입 시점 인증 가드.
// access_token 의 만료시각(JWT exp)을 디코드 → 없거나 만료면 즉시 /login 으로.
// API 호출(버튼 클릭) 전에 미리 걸러서, 작업 도중 401 로 갑자기 로그인 뜨는 것을 방지.

import { useEffect, useState } from "react"
import { usePathname, useRouter, useSearchParams } from "next/navigation"

// 로그인 없이 접근 가능한 공개 경로
const PUBLIC_PATHS = ["/login", "/register", "/verify-email", "/forgot-password", "/terms"]

// JWT exp(초) 디코드 — 유효하면 만료 epoch(ms) 반환, 실패 시 0
function getTokenExpiry(token: string): number {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]))
    return (payload.exp || 0) * 1000
  } catch {
    return 0
  }
}

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()   // 쿼리 변경(?reset= 등)도 감지하기 위해
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    // 공개 경로는 검사 통과
    if (PUBLIC_PATHS.some((p) => pathname.startsWith(p))) {
      setChecked(true)
      return
    }

    const token = localStorage.getItem("access_token")
    const exp = token ? getTokenExpiry(token) : 0

    // 토큰 없음 or 만료(여유 5초) → 로그인으로.
    // 단 refresh_token 이 있으면 인터셉터가 자동 갱신을 시도하므로 통과시킨다.
    if (!token || exp === 0 || exp < Date.now() + 5000) {
      const refresh = localStorage.getItem("refresh_token")
      if (!refresh) {
        router.replace("/login")
        return
      }
    }
    setChecked(true)
  }, [pathname, searchParams, router])

  // 검사 전엔 아무것도 안 보여 깜빡임 방지
  if (!checked) return null
  return <>{children}</>
}